import { useEffect } from 'react';
import {
  SUPPORT_EMAIL,
  SUPPORT_PHONE_DISPLAY,
  SUPPORT_PHONE_TEL,
  SUPPORT_PHONE_IN_DISPLAY,
  SUPPORT_PHONE_IN_TEL,
  PRIVACY_POLICY_URL,
} from '../data/legalContact';

/** Public page — no admin login required. Matches public/support.html for App Store support URL. */
function SupportPage() {
  useEffect(() => {
    document.title = 'Support · Saarthi';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        'content',
        'Saarthi rider support. Call or email for help with taxi bookings, payments, and safety.'
      );
    }
  }, []);

  return (
    <div className="saarthi-support">
      <header className="saarthi-support__header">
        <div className="saarthi-support__wrap">
          <div className="saarthi-support__mark" aria-hidden="true">
            स
          </div>
          <h1>Saarthi Support</h1>
          <p className="saarthi-support__subtitle">Help for the Saarthi taxi rider app</p>
        </div>
      </header>
      <main className="saarthi-support__main">
        <div className="saarthi-support__wrap">
          <div className="saarthi-support__card">
            <h2>How to reach us</h2>
            <p>
              Saarthi is a taxi rider app. Use this page if you need help with a booking, payment, or
              safety issue. This is not a driver hiring form.
            </p>
            <ul>
              <li>
                In the app: open <strong>Safety &amp; support</strong>
              </li>
              <li>
                Email: <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
              </li>
              <li>
                United States:{' '}
                <a href={`tel:${SUPPORT_PHONE_TEL}`}>+1 {SUPPORT_PHONE_DISPLAY}</a> (24×7)
              </li>
              <li>
                India: <a href={`tel:${SUPPORT_PHONE_IN_TEL}`}>{SUPPORT_PHONE_IN_DISPLAY}</a> (24×7)
              </li>
            </ul>
            <p>
              If you are in danger, call local emergency services (911 in the US, 100 in India) first.
            </p>
            <p>
              <a href={PRIVACY_POLICY_URL}>Read the Saarthi Privacy Policy</a>
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default SupportPage;
